import React, { Suspense, useState } from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import Header from '../components/Header';
import { getTool } from './registry';
import { ToolTitleSlotContext } from './ui/titleSlot';
import './ui/tools.css';
import '../styles.css';

const Loading = () => (
  <div style={{ padding: 40, textAlign: 'center', color: '#64748b' }}>Loading tool…</div>
);

function ToolRoute() {
  const { toolId } = useParams();
  const navigate = useNavigate();
  const tool = getTool(toolId);
  const [titleSlot, setTitleSlot] = useState(null);
  if (!tool) return <Navigate to="/tools" replace />;

  const Tool = tool.component;

  return (
    <div>
      <Header />
      <div className="tools-scope tool-page">
        <div className="tool-page-inner">
          <div className="page-title">
            <div className="page-title-main">
              <h1>{tool.name}</h1>
              <div ref={setTitleSlot} className="page-title-extra" />
            </div>
            <button onClick={() => navigate('/tools')} className="close-button">✕</button>
          </div>
          <ToolTitleSlotContext.Provider value={titleSlot}>
            <Suspense fallback={<Loading />}>
              <Tool tool={tool} />
            </Suspense>
          </ToolTitleSlotContext.Provider>
        </div>
      </div>
    </div>
  );
}

export default ToolRoute;
